import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=432d43a2&scoped=true"
import script from "./DownloadButton.vue?vue&type=script&lang=js"
export * from "./DownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432d43a2",
  null
  
)

export default component.exports